import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { loadTrendingMediaByTopics } from '../../../api/topic/load-trending-media-by-topics';
import { Swimlane } from '../../../components/Swimlane/Swimlane';
import { SwimlaneTitle } from '../../../components/Swimlane/SwimlaneTitle';
import { Swipeable } from '../../../components/Swipeable/Swipeable';
import { MediaTeaser } from '../../../components/Teaser/MediaTeaser/MediaTeaser';
import { MediaTeaserPlaceholder } from '../../../components/Teaser/MediaTeaser/MediaTeaserPlaceholder';
import { queryKeys } from '../../../config/use-query';
import { useAxios } from '../../../hooks/use-axios';
import { usePaging } from '../../../hooks/use-paging';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const TrendingByTopics = ({
  topics,
  filterMediaUrn,
  filerShowUrn,
  titleKey
}) => {
  const axios = useAxios();
  const {
    t
  } = useTranslation();
  const topicIds = topics.map(topic => topic.id);
  const {
    data: videos,
    error,
    isLoading
  } = usePaging(queryKeys.TrendingMediaByTopic(topicIds), () => loadTrendingMediaByTopics(axios, topicIds));
  const filteredVideos = videos?.filter(video => video.urn !== filterMediaUrn && video.show?.urn !== filerShowUrn);
  const showSwimlane = !(filteredVideos?.length === 0 && !isLoading || error);
  return /*#__PURE__*/_jsx(Fragment, {
    children: showSwimlane && /*#__PURE__*/_jsxs(Swimlane, {
      children: [/*#__PURE__*/_jsx(SwimlaneTitle, {
        title: t(titleKey ?? 'videoDetailPage.trendingByTopic')
      }), /*#__PURE__*/_jsx(Swipeable, {
        buttonPositionFactor: 9 / 16,
        placeholder: /*#__PURE__*/_jsx(MediaTeaserPlaceholder, {}),
        analyticsTitle: "TrendingMediasByTopic",
        children: filteredVideos?.map((video, index) => /*#__PURE__*/_jsx(MediaTeaser, {
          media: video,
          index: index
        }, video.id))
      })]
    })
  });
};